import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageNotFoundError from "../lib/pageNotFoundError";
import SimplePage from "../components/article/SimplePage";
import { ApiResult } from "../lib/CmsApi";
import PageProps from "../lib/models/pageProps";

export default function Page(props: ApiResult<"loadIfbInfopageBySlug">) {
  return (
    <SimplePage
      contents={{ items: props.contents }}
      title={props.name}
      route={"infoArticle"}
      params={{ slug: props.slug }}
    />
  );
}

Page.getInitialProps = async ({
  api,
  query
}: InitialPropsContext): PageProps<ApiResult<"loadIfbInfopageBySlug">> => {
  const { slug } = query;

  const content = await api.loadIfbInfopageBySlug(slug as string).catch(() => {
    throw new PageNotFoundError();
  });

  let _pageImages;
  try {
    _pageImages = SimplePage.getImages({
      contents: { items: content.contents }
    });
  } catch (error) {
    console.error(error);
  }

  return { ...content, _pageImages };
};
